import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Layout } from 'antd';
import { MDBBtn, MDBContainer, MDBIcon } from 'mdbreact';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AppBar from '@material-ui/core/AppBar';
// import CssBaseline from '@material-ui/core/CssBaseline';
import Hidden from '@material-ui/core/Hidden';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import vi_logo from '../../../Assets/visaero_logo.png';
import vd_logo from '../../../Assets/visadone_logo.png';
// import {ReactComponent as StickerVisaIcon} from '../../../Assets/visa_icon_svg.svg';


// import profile_pic from '../../../Assets/blank-profile-picture.png';
import ListItemIcon from '@material-ui/core/ListItemIcon';
// import { Link as RouterLink } from 'react-router-dom'; 
import styles from './HomeLayout.module.css';
// import edit_icon from '../../../Assets/edit.svg';
import { Avatar } from 'antd';
import ConfigData from '../../../config';

const HomeLayout = props => {
  const { children } = props;
  const { Content } = Layout;
  const { container } = props;
  // const classes = useStyles();
  // const theme = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);

  // handleDrawerToggle = () => {
  //   console.log('clicker')
  //   setMobileOpen(!mobileOpen);
  // }
  const { history } = props.children.props;
  const [selectedIndex, setSelectedIndex] = React.useState(1);

  if (localStorage.getItem('session_id') == null || localStorage.getItem('session_id') == "") {
    window.location.href = "/login"
  }
  const handleProfileClick = () => {
    setSelectedIndex(-1)
    history.push("/profile")
  }

  function handleLogout() {
    localStorage.setItem("session_id", "")
    window.location.href = "/login";
  }

  const brand_color = localStorage.getItem('brand_color')

  const itemList = [
    // {
    //   text: "News and Updates",
    //   icon: <MDBIcon  style={{color:brand_color}} icon="paper-plane" />,
    //   onClick: (event,index) => {
    //     history.push("/news")
    //     //console.log(index)
    //     setSelectedIndex(index)
    //   },
    //   i: 0
    // },
    // {
    //   text: "Dashboard",
    //   icon: <MDBIcon far icon="paper-plane" />,
    //   onClick: () => history.push("/dashboard")
    // },
    {
      text: "Notifications",
      icon: <MDBIcon icon="bell" />,
      onClick: (event, index) => {
        history.push("/notification")
        //console.log(index)
        setSelectedIndex(index)
      },
      i: 0
    },
    {
      text: "New Visa",
      icon: <MDBIcon icon="passport" />,
      onClick: (event, index) => {
        history.push("/new-visa")
        //console.log(index)
        setSelectedIndex(index)
      },
      i: 1
    },
    {
      text: "Track Application",
      icon: <MDBIcon  icon="search" />,
      onClick: (event, index) => {
        history.push("/track-application")
        //console.log(index)
        setSelectedIndex(index)
      },
      i: 2
    },
    {
      text: "Track Sticker Visa",
      // icon: <img src={StickerVisaIcon} height='20px' width='20px' />,
      icon: <i class="fas fa-table"></i>,
      onClick: (event, index) => {
        history.push("/track-sticker-visa")
        //console.log(index)
        setSelectedIndex(index)
      },
      i: 3
    },
    // {
    //   text: "Credit Management",
    //   icon: <MDBIcon far icon="edit" />,
    //   onClick: () => history.push("/manage-credits")
    // },
    // {
    //   text: "Employee Management",
    //   icon: <MDBIcon far icon="edit" />,
    //   onClick: () => history.push("/manage-employee")
    // },
  ]

  const host = localStorage.getItem('host');
  var logo = ''
  if (host == "visaero") {
    logo = vi_logo
  } else if (host == "visadone") {
    logo = vd_logo
  }

  const drawer = (
    <div >
      <div className="text-center mt-3 mb-3"><img width={localStorage.getItem("host") == "visadone" ? 150 : 80} src={logo} className="mb-4"></img></div>
      <div className="text-center mt-3 mb-4">
        <Avatar size={70} src={localStorage.getItem("profile_pic")} className="rounded-circle z-depth-1-half"></Avatar>
      </div>
      {/* <div className="text-center mt-3 mb-4"><img width={70} src={localStorage.getItem("profile_pic")} className="rounded-circle z-depth-1-half"></img></div> */}
      <div className="text-center" id={styles.name}><p>{localStorage.getItem("First_name")} {localStorage.getItem("Last_name")}</p></div>
      <List >
        <ListItem button onClick={handleProfileClick} selected={selectedIndex === 99}>
          <ListItemText className="text-center" style={{ color: brand_color }} >My Profile</ListItemText>
        </ListItem>
      </List>
      <Divider />
      <List>
        {itemList.map((item, index) => {
          //console.log(selectedIndex);
          const { text, icon, onClick, i } = item;
          //console.log("given index >> " + i);
          return (
            <ListItem button key={text} onClick={(event) => onClick(event, i)} selected={selectedIndex === i}>
              {icon && <ListItemIcon style={{ color: selectedIndex === i ? brand_color : "" }} >{icon}</ListItemIcon>}
              <ListItemText primary={text} className={selectedIndex === i ? "listname" : ""} />
            </ListItem>
          );
        })}
      </List>
      <div className="text-center" style={{ padding: '5%', marginTop: '10%' }}>
        <div><small className="text-muted">{`(${ConfigData.configData.version})`}</small></div>
        <MDBBtn id="logoutBtn" style={{ color: 'white', backgroundColor: brand_color, width: '90%', fontSize: 'calc(8px + .5rem)', textTransform: 'none' }} onClick={handleLogout} color="none">Logout</MDBBtn>
      </div>

      <div className="text-center pt-3 pb-3">
            <div><b><small className="text-muted">Powered By</small><div style={{ color: "#663785" }}>Visaero</div></b></div>
      </div>
      {/* <div className="text-center" style={{padding:'1%'}}>
          <RouterLink to="/" ><MDBBtn id="contactBtn" style={{color:brand_color,width:'85%',fontSize:'calc(5px + .5rem)',textTransform:'none'}} color="none">Contact Support</MDBBtn></RouterLink>
      </div> */}
    </div>
  );

  return (
    <>
      <div  >
        <AppBar disableGutters position="absolute" style={{ border: 'none', backgroundColor: brand_color, zIndex: "-1" }} className="pt-5 pb-5 shadow-none">
          <Toolbar disableGutters style={{ background: 'inherit', border: 'none' }}>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              <MDBIcon icon="bars" />
            </IconButton>
          </Toolbar>
        </AppBar>
        <nav style={{ width: '10rem' }}>
          <Hidden smUp implementation="css">
            <Drawer
              container={container}
              variant="temporary"
              open={mobileOpen}
              onClose={() => setMobileOpen(!mobileOpen)}
              ModalProps={{
                keepMounted: true,
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>
          <Hidden xsDown implementation="css">
            <Drawer
              variant="permanent"
              open
            >
              {drawer}
            </Drawer>
          </Hidden>
        </nav>
      </div>
      <main className={styles.main} style={{ position: "relative", marginTop: "-40px" }} >
        <MDBContainer fluid style={{ paddingTop: '5rem', }}>
          {children}
        </MDBContainer>
      </main>
    </>
  );
};

HomeLayout.propTypes = {
  children: PropTypes.node
};

export default HomeLayout;